import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type PslfGroupModel from 'tio-common/models/pslf-group';
import type PslfProfileModel from 'tio-common/models/pslf-profile';
import type PslfTemplate from 'tio-common/models/pslf-template';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';
import type { NotificationsService } from 'tio-reimagined/components/notifications';
import type PslfFieldModel from 'tio-common/models/pslf-field';

export default class AuthenticatedPslfDashboardStartNewRoute extends Route {
  @service declare store: StoreService;
  @service declare partner: PartnerService;
  @service declare notifications: NotificationsService;

  async model() {
    const parentModel = (await this.modelFor('authenticated.pslf')) as {
      pslfProfile: PslfProfileModel;
      groups: PslfGroupModel[];
    };

    const currentEmployee = parentModel.pslfProfile.employee;

    const templateRes = await this.store.query('pslf-template', {
      include: 'pslf-fields',
      pslfProfileId: parentModel.pslfProfile.id,
      reload: true,
    });
    // TODO: figure out a better way to fetch the correct template
    const pslfTemplate = templateRes?.[0] as PslfTemplate;

    // HACK: attempting to fix a bug in staging where the template and fields are both loaded but the relationship is not set
    // this is only occurring when navigating from the pslf dashboard, going straight to start-new has no issues
    if (!pslfTemplate?.pslfFields?.length) {
      const fieldsRes = (await this.store.query('pslf-field', {
        filter: { pslfTemplateId: pslfTemplate.id },
        pslfProfileId: parentModel.pslfProfile.id,
      })) as PslfFieldModel[];

      pslfTemplate.pslfFields = fieldsRes;
    }

    return {
      employee: currentEmployee,
      groups: parentModel.groups,
      pslfTemplate,
    };
  }
}
